export default __webpack_public_path__ + "static/media/2223 cutlery top.adfd52da.png";